import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxBootstrapConfirmService } from 'ngx-bootstrap-confirm';

import { DocumentReference } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';

import { User } from '../../../autenticacion/models/user';

import { TemporadaService } from '../services/temporada.service';
import { Temporada } from '../models/temporada';
import { TemporadaViewModel } from '../models/temporada-view-model';

@Component({
    selector: 'app-temporada-form',
    templateUrl: './temporada-form.component.html',
    styleUrls: ['./temporada-form.component.scss']
})
export class TemporadaFormComponent implements OnInit {
    temporadaForm: FormGroup;

    editMode: string = 'C';
    temporada: TemporadaViewModel;

    user: User;

    constructor(private formBuilder: FormBuilder,
        public activeModal: NgbActiveModal,
        private temporadaService: TemporadaService,
        private afAuth: AngularFireAuth,
        private ngxBootstrapConfirmService: NgxBootstrapConfirmService) { }

    ngOnInit(): void {

        this.temporadaForm = this.formBuilder.group({
            nombre: ['', Validators.required],
            descripcion: ['', Validators.required],
            fechaInicio: ['', Validators.required],
            fechaFin: ['', Validators.required],
            finalizada: false,
            codFmp: ['']
        });

        if (this.editMode != 'C') { this.loadTemporada(this.temporada); }

        this.afAuth.user.subscribe(user => {
            if (user) {
                this.user = user;
            }
        })
    }

    loadTemporada(temporada: TemporadaViewModel) {
        this.temporadaForm.patchValue(temporada);
    }

    saveTemporada() {
        // Validar el formulario
        if (this.temporadaForm.invalid) {
            return;
        }

        let options = {
            title: 'Desea guardar los cambios?',
            confirmLabel: 'Ok',
            declineLabel: 'Cancelar'
        }
        this.ngxBootstrapConfirmService.confirm(options).then((res: boolean) => {
            if (res) {
                // Enviar la informaci�n hacia Firebase
                if (this.editMode == 'C') {
                    let temporada: Temporada = this.temporadaForm.value;
                    temporada._fechaCreacion = new Date();
                    temporada._userCreacion = this.user.uid;
                    temporada._fechaModificacion = new Date();
                    temporada._userModificacion = this.user.uid;
                    temporada._lgBaja = false;
                    this.temporadaService.saveTemporada(temporada)
                        .then(response => this.handleSuccessfulSaveTemporada(response, temporada))
                        .catch(err => console.error(err));
                } else if (this.editMode == 'M') {
                    let temporada: TemporadaViewModel = this.temporadaForm.value;
                    temporada.id = this.temporada.id;
                    temporada._fechaModificacion = new Date();
                    temporada._userModificacion = this.user.uid;
                    this.temporadaService.editTemporada(temporada)
                        .then(() => this.handleSuccessfulEditTemporada(temporada))
                        .catch(err => console.error(err));
                }
            } else {
                console.log('Cancel save');
            }
        });
    }

    handleSuccessfulSaveTemporada(response: DocumentReference, temporada: Temporada) {
        // Enviar la informaci�n al todo-list
        this.activeModal.dismiss({ temporada: temporada, id: response.id, editMode: 'C' });
    }

    handleSuccessfulEditTemporada(temporada: TemporadaViewModel) {
        this.activeModal.dismiss({ temporada: temporada, id: temporada.id, editMode: 'M' });
    }

    handleSuccessfulDeleteTemporada(temporada: TemporadaViewModel) {
        this.activeModal.dismiss({ temporada: temporada, id: temporada.id, editMode: 'D' });
    }

    handleDeleteClick() {
        let options = {
            title: 'Desea borrar el registro?',
            confirmLabel: 'Ok',
            declineLabel: 'Cancelar'
        }
        this.ngxBootstrapConfirmService.confirm(options).then((res: boolean) => {
            if (res) {
        let temporada: TemporadaViewModel = this.temporadaForm.value;
        temporada.id = this.temporada.id;
        temporada._lgBaja = true;
        temporada._fechaBaja = new Date();
        temporada._userBaja = this.user.uid;
        this.temporadaService.editTemporada(temporada)
            .then(() => this.handleSuccessfulDeleteTemporada(temporada))
            .catch(err => console.error(err));
            } else {
                console.log('Cancel delete');
            }
        });
        
    }
}
